/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/common/recipientUtils"/>

export type GenericRecipientType = 'To' | 'Cc' | 'Bcc';

export interface GenericRecipient {
    emailAddress: string;
    type: GenericRecipientType;
}

/**
 * Filters recipients by type
 * @param recipients Array of recipients
 * @param type Type to filter by
 * @returns Filtered array of recipients
 */
export function filterRecipientsByType<T extends GenericRecipient>(recipients: T[], type: GenericRecipientType): T[] {
    return recipients.filter((recipient) => recipient.type === type);
}

/**
 * Gets recipients grouped into separate arrays for To, Cc, and Bcc
 * @param recipients Array of recipients
 * @returns Object with separate arrays for each type
 */
export function separateRecipientsByType<T extends GenericRecipient>(
    recipients: T[]
): {
    toRecipients: T[];
    ccRecipients: T[];
    bccRecipients: T[];
} {
    return {
        toRecipients: filterRecipientsByType(recipients, 'To'),
        ccRecipients: filterRecipientsByType(recipients, 'Cc'),
        bccRecipients: filterRecipientsByType(recipients, 'Bcc'),
    };
}
